import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientMypageListItem } from '@/feature/hotline/client/mypage/component/HotlineClientMypageList/HotlineClientMypageListItem';
import { hotlineClientMypageListStyle } from '@/feature/hotline/client/mypage/component/HotlineClientMypageList/style';
/**
 * ホットライン マイページで使用する一覧コンポーネント
 * @memo /hotline 配下ではないがホットラインの定数等を使用するため、ホットラインのディレクトリに配置
 */
export const HotlineClientMypageList = (props) => {
    const { className = '', list } = props;
    const style = hotlineClientMypageListStyle();
    if (list === null) {
        return (_jsx("div", Object.assign({ className: style.noDataBase({ class: className }) }, { children: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u6642\u9593\u3092\u7F6E\u3044\u3066\u304B\u3089\u3084\u308A\u76F4\u3059\u304B\u3001\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002" })));
    }
    if (!list.length) {
        return (_jsx("div", Object.assign({ className: style.noDataBase({ class: className }) }, { children: "\u73FE\u5728\u3001\u76F8\u8AC7\u306F\u3042\u308A\u307E\u305B\u3093" })));
    }
    return (_jsx("ul", Object.assign({ className: style.base({ class: className }) }, { children: list.map((item) => (_jsx(HotlineClientMypageListItem, { item: item }, item.id))) })));
};
